
import { Union, Record } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection } from "../../../Shared/Shared.js";
import { RowValidation_$reflection } from "../../../Shared/Updater.js";
import { union_type, class_type, string_type, record_type, list_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class State extends Record {
    constructor(FormState, Rows) {
        super();
        this.FormState = FormState;
        this.Rows = Rows;
    }
}

export function State_$reflection() {
    return record_type("Importer.Updater.Tool.Types.State", [], State, () => [["FormState", FormState_$reflection()], ["Rows", list_type(RowValidation_$reflection())]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateData", "DataImported", "Validate", "ValidationCompleted", "BlobReceived", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Importer.Updater.Tool.Types.Msg", [], Msg, () => [[], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("Browser.Types.FormData", undefined)]], [["Item", ClientApiResponse$1_$reflection(list_type(RowValidation_$reflection()))]], [["Item1", class_type("Browser.Types.Blob", undefined)], ["Item2", string_type]], [["Item", class_type("System.Exception")]]]);
}

